import React from 'react';

const WidgetSkeleton: React.FC = () => {
  return (
    <div className="stats-card animate-pulse">
      <div className="p-6 space-y-6">
        <div className="h-6 w-1/4 bg-light-hover dark:bg-dark-hover rounded-lg" />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="rounded-lg bg-light-hover dark:bg-dark-hover p-4">
              <div className="h-4 w-1/2 bg-gray-200 dark:bg-gray-700 rounded mb-2" />
              <div className="h-6 w-1/3 bg-gray-200 dark:bg-gray-700 rounded" />
            </div>
          ))}
        </div>

        <div className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 dark:via-white/10 to-transparent skeleton-wave" />
          <div className="space-y-4">
            <div className="h-4 w-1/6 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="space-y-3">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="h-12 bg-light-hover dark:bg-dark-hover rounded-lg" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidgetSkeleton;